module.exports = __webpack_public_path__ + "static/img/s1.716e097.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/s1.jpg
// module id = /92c
// module chunks = 1